import { render, staticRenderFns } from "./PackageRegistrationCreate.vue?vue&type=template&id=0b84c215&scoped=true"
import script from "./PackageRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./PackageRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./PackageRegistrationCreate.vue?vue&type=style&index=0&id=0b84c215&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84c215",
  null
  
)

export default component.exports